import { memo } from "react";
import { pipe } from "fp-ts/function";
import * as Option from "fp-ts/Option";
import * as M from "@discovery/prelude/lib/data/maybe";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { HeaderVariants, Typography, Tags } from "../../atoms/typography";
import * as styles from "./styles.css";
export const ShowGenres = memo(({ genre }) => (React.createElement("div", { className: styles.genres, id: "#showPageGeners" }, genre.map((itemM) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: styles.separation }),
    React.createElement(RenderMaybe, null, M.map((item) => (React.createElement(Typography, { classNameM: M.of(styles.genresType), variant: HeaderVariants.headingSix, tag: Tags.h6, key: item },
        React.createElement(React.Fragment, null, item))), itemM))))))));
export const ContentRating = memo(({ contentRatingsShowM, contentRatingsDescriptorM }) => {
    const contentRatings = pipe(contentRatingsShowM, Option.getOrElse(() => []));
    const contentDescriptors = pipe(contentRatingsDescriptorM, Option.getOrElse(() => []));
    return (React.createElement("div", { className: contentRatings.length > 0 || contentDescriptors.length > 0
            ? styles.contentRatingWrapper
            : "" },
        contentRatings.length > 0 && (React.createElement("div", null,
            React.createElement(Typography, { classNameM: M.of(styles.contentRatingTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, "Age Rating : ")))),
        contentRatings &&
            contentRatings.map((item, index) => {
                return (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { classNameM: M.of(styles.contentRatingTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                        React.createElement(React.Fragment, null, item.code)),
                    index < contentRatings.length - 1 && (React.createElement("div", { className: styles.separation }))));
            }),
        contentDescriptors.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.dash }),
            React.createElement("div", null,
                React.createElement(Typography, { classNameM: M.of(styles.contentRatingTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, "Contains : "))))),
        contentDescriptors &&
            contentDescriptors.map((item) => (React.createElement(React.Fragment, null,
                React.createElement(Typography, { classNameM: M.of(styles.contentRatingTexts), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, item.code)),
                React.createElement("div", { className: styles.separation }))))));
});

